<template>
  <div class="logo">
    <NuxtLink to="/" class="flex">
      <!-- <img src="/images/logos/dark-logo-icon.svg" /> -->
      <!-- <img src="/images/logos/dark-logo-text.svg" class="pl-3" /> -->
    </NuxtLink>
  </div>
</template>
<script setup lang="ts"></script>
